module.exports = __webpack_public_path__ + "media/svg-new/google 1-b0571c4c.svg";